import { API } from "../../utils/api";
import { getAdminUserList, updateUserStatus } from "../Reducers/AdminReducer";
import { getAdminPaymentsList } from "../Reducers/BookingReducer";

export const getUsersListAction = (data, dispatch) =>
  API.getAdminUserList(data).then((res) => {
    if (res && res.type === "success" && res.data) {
      dispatch(getAdminUserList({ items: res.data }));
    }
    return res;
  });

export const updateUserStatusAction = (data, dispatch) =>
  API.updateUserStatus(data).then((res) => {
    if (res.type === "success") {
      dispatch(updateUserStatus({ id: data.id }));
    }
  });

export const getAdminPaymentsAction = (data, dispatch) =>
  API.getAdminPayments(data).then((res) => {
    if (res && res.type === "success" && res.data) {
      dispatch(getAdminPaymentsList({ items: res.data }));
    }
    return res;
  });

// App version settings — singleton config consumed by the mobile cold-start
// update check. The form holds the value, so no redux storage needed here.
export const getAppVersionAction = () =>
  API.getAppVersionInfo().then((res) => res);

export const updateAppVersionAction = (data) =>
  API.updateAppVersionInfo(data).then((res) => res);
